<template>
  <div>
    <template v-if="width < 2054 && width > 1699">
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
      </vs-row>
    </template>
    <vx-card title="환자 리스트">
      <div class="flex justify-end flex-wrap mb-3">
        <vs-button radius color="primary" icon-pack="feather" icon="icon-headphones"
          @click="onClickMemberView('cs')" />
        <!-- <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="onClickModifyView(-1, '')" /> -->
        <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="onClickMemberView('patient')" />
        <template v-if="userLevel == 2">
          <vs-button radius color="primary" icon-pack="feather" icon="icon-upload" @click="openUploadPopup()" />
          <vs-button radius color="primary" icon-pack="feather" icon="icon-download" @click="listDownload()" />
          <vs-button radius color="primary" icon-pack="feather" icon="icon-download-cloud" @click="listDownloadEssential()" />
          <vs-button radius color="primary" icon-pack="feather" icon="icon-message-circle" @click="kakaoAllSend()" />
        </template>
      </div>

      <vs-row class="mb-3" vs-type="flex" vs-align="center">
        <vs-select autocomplete class="w-auto mr-3" v-model="searchStaus" placeholder="상태 선택" @change="init('', 'S')">
          <vs-select-item value="" text="상태 선택" />
          <vs-select-item :value="item.CD_STATUS" :text="item.STATUS_NAME" v-for="(item, index) in statusList"
            :key="index" />
        </vs-select>
        <vs-input class="w-1/5" icon="search" placeholder="환자 이름 or 전화번호 or 차트번호 or 진단명 입력 후 엔터(Enter)" v-model="search"
          @keyup.enter="init('', 'I')" />
        <vs-button class="ml-1" @click="init('', 'init')">초기화</vs-button>
      </vs-row>
      <vs-button type="line" v-for="(item, index) in tab_menu" :key="index" :class="activeMenu(item.MEDICAL_ROOM_SEQ)"
        @click="init(item.MEDICAL_ROOM_SEQ, 'T')">{{ item.MEDICAL_ROOM_NM }}</vs-button>
      <div class="tb_wrap" style="width:100%;overflow-x:auto;">
        <div class="tb_box">
          <table id="list" style="width:100%;min-width:1400px;" class="border-collapse">
            <thead>
              <tr>
                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  v-for="(item, index) in tb_menu" :key="index">
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tr :key="index" v-for="(tr, index) in lists">
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.MEDICAL_ROOM_NUMBER_NM }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.CHART_NO }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.PATIENT_USERNAME }} 
                <br/>
                <span style="color: #fc4545">{{ tr.IN_LONG_TERM == 'Y' ? '장기미내원환자' : '' }}</span>
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.PATIENT_PHONE }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.PATIENT_AGE }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.PATIENT_GENDER_CONVERT }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.STATUS_NAME }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.MAIN_CS_NM }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.MEDICAL_NM }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center">
                {{ tr.WEST_MEDICAL_NM }}
              </td>
              <td class="border border-solid d-theme-border-grey-light text-center"> 
                {{ tr.CONSULT_DOCTOR }}
              </td>

              <td class="border border-solid d-theme-border-grey-light">
                <vs-row vs-type="flex" vs-justify="center">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <!-- <vx-tooltip text="카톡보내기" position="top"> -->
                    <vs-button color="warning" type="line" icon-pack="feather" icon="icon-message-circle"
                      @click="onClickKakao(index)" />

                    <!-- <a href="#" @click="onClickAlram(index)">알림톡</a> -->
                    <!-- </vx-tooltip> -->
                    <!-- <vx-tooltip text="스케줄" position="top"> -->
                    <vs-button color="success" type="line" icon-pack="feather" icon="icon-calendar"
                      @click="onClickSchedule(index)" />
                    <!-- </vx-tooltip> -->
                    <!-- <vx-tooltip text="수정" position="top"> -->
                    <vs-button color="primary" type="line" icon-pack="feather" icon="icon-edit-2"
                      @click="onClickMemberView('patient',tr.PATIENT_UID)" />
                    <vs-button color="primary" type="line" icon-pack="feather" icon="icon-headphones"
                      v-show="tab_sum & 1024" @click="onClickMemberView('cs',tr.PATIENT_UID)" />
                    <vs-button color="primary" type="line" icon-pack="feather" icon="icon-file" v-show="tab_sum & 1024"
                      @click="print(tr.PATIENT_UID)" />

                    <!-- </vx-tooltip> -->
                    <!-- <vx-tooltip text="삭제" position="top"> -->
                    <vs-button color="danger" type="line" icon-pack="feather" icon="icon-x"
                      @click="onClickDeleteConfirm(index)" />
                    <!-- </vx-tooltip> -->
                  </vs-col>
                </vs-row>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <br />
      <vs-pagination :total="pageCount" v-model="page" @input="init(medical_room_seq, 'P')" :max="7"></vs-pagination>
    </vx-card>

    <vs-popup title="알림톡 발송" :active.sync="kakaoPopup">
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 ">
            <label for="" class="vs-select--label">날짜 선택</label>
            <date-picker name="kakao_date" v-model="kakao_date" :locale="'ko'" valueType="format"
              class="vs-inputx normal w-full"></date-picker>
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <vs-select autocomplete class="w-auto" name="messageSelect" v-model="messageSelect" label="메시지 수동 발송 선택"
              placeholder="선택해주세요.">
              <vs-select-item value="" text="초기값" />
              <vs-select-item value="1" text="스케줄(기존)" />
              <vs-select-item value="K" text="직통번호 안내" />
              <vs-select-item value="M" text="퇴원약 주사 안내" />
              <vs-select-item value="A" text="병실 안내" />
              <vs-select-item value="B" text="비용 안내" />
              <vs-select-item value="C" text="입원예정서 안내" />
              <vs-select-item value="D" text="위치 안내" />
              <vs-select-item value="E" text="방문상담 전날" />
              <vs-select-item value="F" text="방문상담 당일" />
              <vs-select-item value="G" text="상담 후" />
              <vs-select-item value="H" text="상담 후(부인과)" />
              <vs-select-item value="I" text="입원확정시" />
              <vs-select-item value="J" text="입원 전날" />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 ">
            <label for="" class="vs-input--label">메시지 발송 대상자</label>
            <div class="vx-row mb-3 ml-2">
              <vs-checkbox type="checkbox" vs-value="1" v-model="messageResponder_1">
                환자본인</vs-checkbox>
              <vs-checkbox type="checkbox" vs-value="2" v-model="messageResponder_2">
                보호자</vs-checkbox>
              <vs-checkbox type="checkbox" vs-value="3" v-model="messageResponder_3">
                보호자2</vs-checkbox>
            </div>
          </div>
        </div>

        <div class="vx-row" style="margin-top:300px;">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="kakaoSend">즉시발송</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="kakaoClose">닫기</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>


    <vs-popup id="alramTalk" title="알림톡 발송" :active.sync="alramTalk">
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 ">
            <label for="" class="vs-select--label">날짜 선택</label>
            <date-picker name="kakao_date" v-model="kakao_date" :locale="'ko'" valueType="format"
              class="vs-inputx normal w-full"></date-picker>
          </div>

        </div>

        <div class="vx-row" style="margin-top:300px;">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="kakaoSend">즉시발송</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="kakaoClose">닫기</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
    <!--상담내역팝업끝-->
    <ExcelUpload ref="excelupload" :medicalMemberList="medicalMemberList"
      :medicalRoomNumberList="medicalRoomNumberListEtc" :statusList="statusList" :mealTimeList="mealTimeList"
      :mealNameList="mealNameList" :addrOptions="addrOptions" :protectorList="protectorList" :coronaList="coronaList"
      :anamnesisList="anamnesisList" :bodyPartList="bodyPartList"></ExcelUpload>
    <myPrint id="myPrintId" ref="myPrint" style="display: none;" />

  </div>
</template>


<script>
import axiosClass from "@/../util/axiosClass";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { validationMobile } from "@/../util/validation";
import store from "@/store/store";
import ExcelUpload from "./component/ExcelUploader.vue";
import * as XLSX from 'xlsx';
import { EventBus } from '../../../util/vue-event-bus';
import dateClass from "@/../util/dateClass";
import moment from "moment";
import Vue from "vue";
import VueHtml2Canvas from "vue-html2canvas";
import myPrint from "../printComponent/myPrint.vue";
Vue.use(VueHtml2Canvas);
export default {
  components: {
    DatePicker,
    ExcelUpload,
    myPrint,
  },
  data() {
    return {
      pdfKey: 0,
      addrOptions: [],
      openPopup1: false,
      userUid: "",
      lists: [],
      page: 1,
      pageLimit: 15,
      totalCount: 0,
      pageCount: 0,
      listIndex: -1,
      patientUid: "",
      patientName: "",
      search: "",
      chartNo: "",
      patientUsername: "",
      sickNess: "",
      gisu: "",
      jumin: "",
      patientBirthday: "",
      patientGender: "",
      age: "",
      plan: "",
      newRe: "신입",
      cdStatus: "",
      inInitDate: "",
      inDate: "",
      inTime: "",
      outTime: "",
      outDate: "",
      completeYn: "N",
      mealTime: "",
      mealName: "",
      mealMemo: "",
      breakfast_mealName: "",
      lunch_mealName: "",
      dinner_mealName: "",
      medical_member_name: "",
      westMedicalNm: "",
      patientPhone: "",
      address: "",
      protectorPhone: "",
      protectorPhone2: "",
      protectorYN: "N",
      medicalName: "",
      medicalNameText: "",
      insuranceChk: false,
      insuranceName: "",
      insuranceNameText: "",
      inLimit: "",
      inLimitText: "",
      inGuarantee: "",
      balance: "",
      confirmDate: dateClass.getDate("YYYY-MM-DD"),
      outpatDayLimit: "",
      outpatDayLimitText: "",
      outPatCount: "",
      indemStdt: "",
      indemEnddt: "",
      joinDate: "",
      memo: "",
      corona: "",
      medicalMemberList: [],
      medicalCenterList: [],
      insuranceCenterList: [],
      statusList: [],
      medicalRoomNumberListEtc: [],
      tab_menu: [],
      medical_room_seq: "",
      tb_menu: [
        "관리병동",
        "차트번호",
        "이름",
        "전화번호",
        "나이",
        "성별",
        "상태",
        "주상담자",
        "한방주치의",
        "양방주치의",
        "병동주치의",
        "관리",
      ],
      searchStaus: "",
      kakaoPopup: false,
      kakao_date: dateClass.getDate("YYYY-MM-DD"),
      juminTF: false,
      medicalRoomList: [],
      medicalRoomNm: "",
      medicalRoomNumberList2: [],
      medicalRoomNumberNm: "",
      medicalRoomNumberNm_detail: "",
      medicalRoomNumberCntList: [],
      medicalRoomNumberCnt: "",
      sickNessList: [],
      sickNessText: "",
      addressList: [],
      addressText: "",
      protectorList: [],
      protector: "",
      protector2: "",
      mealTimeList: [],
      mealNameList: [],
      mealMemoList: [],
      mealMemoText: "",
      coronaList: [],
      bodyPartList: [],
      anamnesisList: [],
      bodyPart: "",
      diagnosisDate: "",
      operationDate: "",
      metastasisYn: "",
      metastasisPart: "",
      anticancerDate: "",
      radiotherapyDate: "",
      antiagentYn: "Y",
      antiagent: "",
      medication: "",
      anamnesisYn: "N",
      anamnesis: [],
      anamnesisEtc: "",
      csPopup: false,
      csPathList: [],
      csCateList: [],
      csMemberList: [],
      mainCsMemberList: [],
      csFavorList: [],
      csIssueList: [],
      csDatas: [],
      nutritionMemo: "",
      popTabIdx: 1,
      tab_sum: 0,
      expire: false,
      width: window.innerWidth,
      cdStatusChange_YN: "",
      kakao_sender: 1,
      csRel: ["환자본인", "보호자1", "보호자2"],
      etcMemo: "",
      roomMemo: "",
      csMemo: "",
      cs2Memo: "",
      roomlist: [],
      tabArray_01: [],
      mainCs: "",
      mainCsCaller: "1",
      mainCsCallerPhone: "",
      initPath: "",
      issueText: "",
      userLevel: "",

      alramTalk: false,
      alramTalkData1: false,
      alramTalkData2: false,
      alramTalkData3: false,
      alramTalkData4: false,
      alramTalkData5: false,
      alramTalkData6: false,
      messageSelect: "",
      messageResponder_1: false,
      messageResponder_2: false,
      messageResponder_3: false,
      classInfo: "1",
    };
  },
  methods: {
    async print(uid) {
      try {
        const myPrint = document.getElementById("myPrintId");
        myPrint.style.display = "block";  // 출력할 컴포넌트 보이기

        // printComponent() 메서드 실행
        await this.$refs.myPrint.printComponent(uid);

        myPrint.style.display = "none";  // 출력할 컴포넌트 숨기기
      } catch (error) {
        console.error(error);
      }
    },

    async init(medical_room_seq, type) {
      try {
        this.userUid = store.getters.getUID;
        this.userLevel = store.getters.getCDLEVEL;
        // console.info(store.getters.getCDLEVEL);
        // console.info(store);
        if (type == "init") {
          this.search = "";
          this.searchStaus = "";
          this.medical_room_seq = "";
        }
        let searchStatusCheck = "";
        if (this.searchStaus == "") {
          if (medical_room_seq == "" || medical_room_seq == undefined) {
            this.medical_room_seq = "";
            searchStatusCheck = "";
          } else {
            if (medical_room_seq < "0106") {
              searchStatusCheck = "6";
            }
            if (medical_room_seq == "0106") {
              searchStatusCheck = "7";
            }
            if (medical_room_seq == "0107") {
              searchStatusCheck = "8";
            }
            if (medical_room_seq == "0108") {
              searchStatusCheck = "9";
            }
            if (medical_room_seq == "0197") {
              searchStatusCheck = "13";
            }
            if (medical_room_seq == "0198") {
              searchStatusCheck = "11";
            }
            if (medical_room_seq == "0199") {
              searchStatusCheck = "12";
            }
            this.medical_room_seq = medical_room_seq;
          }
        } else {
          searchStatusCheck = this.searchStaus;
          this.medical_room_seq = "";
        }

        if (type != "P") {
          this.page = 1;
        }

        let params = {
          userUid: this.userUid,
          page: this.page,
          pageLimit: this.pageLimit,
          search: this.search,
          medical_room_seq: this.medical_room_seq,
          searchStaus: searchStatusCheck,
        };
        // console.info(params);

        this.$vs.loading({
          type: "default",
          container: "#list",
          background: "rgba(0,0,0,0.1)",
          color: "primary",
          scale: 1.5,
        });

        // console.log(params);
        const { data } = await axiosClass.get(
          "/api/patient/list",
          params,
          true
        );

        this.lists = data.lists;
        this.roomlist = data.roomlist;
        this.totalCount = data.totalCount;
        this.pageCount = data.pageCount;
        this.tab_menu = data.tab_menu;
        this.medicalMemberList = data.medicalMemberList;
        this.medicalCenterList = data.medicalCenterList;
        this.insuranceCenterList = data.insuranceCenterList;

        this.sickNessList = data.sickNessList;
        this.addressList = data.addressList;
        this.protectorList = data.protectorList;

        this.mealTimeList = data.mealTimeList;

        this.mealNameList = data.mealNameList;

        this.mealMemoList = data.mealMemoList;
        this.coronaList = data.coronaList;

        if (this.addrOptions.length == 0) {
          let addrOptions_Obj = {};
          addrOptions_Obj.group = [];
          for (let i = 0; i < data.addressList.length; i++) {
            const obj = data.addressList[i];
            const _do = obj.DO;
            const _bf_do = i > 0 ? data.addressList[i - 1].DO : "";
            const _si = obj.SI;
            const groupObj = { text: _si, value: _si };
            if (_do != _bf_do) {
              if (i > 0) {
                this.addrOptions.push(addrOptions_Obj);
              }
              addrOptions_Obj = {};
              addrOptions_Obj.group = [];
              addrOptions_Obj.title = _do;
            } else {
              if (data.addressList.length == i + 1) {
                this.addrOptions.push(addrOptions_Obj);
              }
            }
            addrOptions_Obj.group.push(groupObj);
          }
        }

        this.statusList = data.statusList;
        this.medicalRoomNumberListEtc = data.medicalRoomNumberListEtc;
        this.medicalRoomList = data.medicalRoomList;
        this.bodyPartList = data.bodyPartList;
        this.anamnesisList = data.anamnesisList;
        this.csPathList = data.csPathList;
        this.csCateList = data.csCateList;
        this.csMemberList = data.csMemberList;
        this.mainCsMemberList = data.mainCsMemberList;
        this.csFavorList = data.csFavorList;
        this.csIssueList = data.csIssueList;

        console.info("csMemberList:" + this.csMemberList[0]);
        setTimeout(() => {
          this.$vs.loading.close("#list > .con-vs-loading");
        }, 100);
      } catch (e) {
        console.log(e.response.data);
      }
    },

    textAreainput(value) {
      this.$emit("input", value);
      this.textArearesize();
    },
    textArearesize($event) {
      if (!this.autoresize) return;
      this.$textarea.style.height = "1px";
      this.$textarea.style.height = `${this.$textarea.scrollHeight + 12}px`;
    },
    //입원예정일 입력 시 시간 초기화 + 입원예정시간, 식사구분, 입원일 식이, 입원일 식이 비고, 코로나검사여부
    inTimeReset() {
      this.inTime = "";
      this.mealTime = "";
      this.mealName = "";
      this.mealMemo = "";
      this.corona = "";
    },

    csContentsData(csContents) {
      return "111";
    },
    //환자 추가 및 수정 팝업열기
    async onClickModifyView(index, type) {
      try {
        if (index > 0) {
          this.statusCheck(
            this.lists[index].COMPLATE_YN,
            this.lists[index].IN_INIT_DATE,
            this.lists[index].IN_DATE,
            this.lists[index].OUT_DATE
          );
        }

        this.popTabIdx = 1;
        this.patientUid = index < 0 ? "" : this.lists[index].PATIENT_UID;
        this.chartNo = index < 0 ? "" : this.lists[index].CHART_NO;
        this.patientUsername =
          index < 0 ? "" : this.lists[index].PATIENT_USERNAME;
        this.sickNess = index < 0 ? "" : this.lists[index].SICKNESS;
        this.gisu = index < 0 ? "" : this.lists[index].GISU;
        this.jumin = index < 0 ? "" : this.lists[index].PATIENT_JUMIN;
        this.patientBirthday =
          index < 0 ? "" : this.lists[index].PATIENT_BIRTHDAY;
        this.patientGender = index < 0 ? "" : this.lists[index].PATIENT_GENDER;
        this.age = index < 0 ? 0 : this.lists[index].PATIENT_AGE;
        this.plan = index < 0 ? "" : this.lists[index].PLAN;


        console.log("plan:" + this.plan.includes("완퇴"));
        //특정문자 포함 여부 상태값
        /*
                if (this.plan.includes('완퇴')) {
                    this.cdStatus = '10';
                    this.medicalRoomNumberNm = '완퇴';
                    this.statusCheck(this.lists[index].COMPLATE_YN, this.lists[index].IN_INIT_DATE, this.lists[index].IN_DATE, this.lists[index].OUT_DATE);
                    console.info('onClickModifyView process : 완퇴');
                }
                */
        if (index < 0) {
          this.expire = false;
        } else {
          if (this.lists[index].EXPIRE == "Y") {
            this.expire = true;
          } else {
            this.expire = false;
          }
        }
        this.classInfo = index < 0 ? "1" : this.lists[index].CLASS_INFO;
        this.newRe = index < 0 ? "" : this.lists[index].NEW_RE;
        this.cdStatus = index < 0 ? "" : this.lists[index].CD_STATUS;
        console.log("cdStatus=============>" + this.cdStatus);
        this.inInitDate = index < 0 ? "" : this.lists[index].IN_INIT_DATE;
        this.inDate = index < 0 ? "" : this.lists[index].IN_DATE;
        this.inTime = index < 0 ? "" : this.lists[index].IN_TIME;
        this.outTime = index < 0 ? "" : this.lists[index].OUT_TIME;
        this.outDate = index < 0 ? "" : this.lists[index].OUT_DATE;
        this.completeYn = index < 0 ? "N" : this.lists[index].COMPLATE_YN;
        this.mealTime = index < 0 ? "" : this.lists[index].MEAL_TIME;
        this.mealName = index < 0 ? "" : this.lists[index].MEAL_NAME;
        this.mealMemo = index < 0 ? "" : this.lists[index].MEAL_MEMO;

        this.breakfast_mealName =
          index < 0 ? "" : this.lists[index].BREAKFAST_MEAL_NAME;
        this.lunch_mealName =
          index < 0 ? "" : this.lists[index].LUNCH_MEAL_NAME;
        this.dinner_mealName =
          index < 0 ? "" : this.lists[index].DINNER_MEAL_NAME;
        this.medical_member_name =
          index < 0 ? "" : this.lists[index].MEDICAL_NM;
        this.westMedicalNm = index < 0 ? "" : this.lists[index].WEST_MEDICAL_NM;
        this.patientPhone = index < 0 ? "" : this.lists[index].PATIENT_PHONE;
        this.address = index < 0 ? "" : this.lists[index].ADDRESS;
        this.protectorPhone =
          index < 0 ? "" : this.lists[index].PROTECTOR_PHONE;
        this.protectorPhone2 =
          index < 0 ? "" : this.lists[index].PROTECTOR_PHONE2;
        this.protectorYN = index < 0 ? "N" : this.lists[index].PROTECTOR_YN;
        this.protector = index < 0 ? "" : this.lists[index].PROTECTOR;
        this.protector2 = index < 0 ? "" : this.lists[index].PROTECTOR2;

        this.bodyPart = index < 0 ? "" : this.lists[index].BODYPART;
        this.diagnosisDate = index < 0 ? "" : this.lists[index].DIAGNOSIS_DATE;
        this.operationDate = index < 0 ? "" : this.lists[index].OPERATION_DATE;
        this.metastasisYn = index < 0 ? "" : this.lists[index].METASTASIS_YN;
        this.metastasisPart =
          index < 0 ? "" : this.lists[index].METASTASIS_PART;
        this.anticancerDate =
          index < 0 ? "" : this.lists[index].ANTICANCER_DATE;
        this.radiotherapyDate =
          index < 0 ? "" : this.lists[index].RADIOTHERAPY_DATE;
        this.antiagentYn = "Y"; //index < 0 ? 'N' : this.lists[index].ANTIAGENT_YN;
        this.antiagent = index < 0 ? "" : this.lists[index].ANTIAGENT;
        this.medication = index < 0 ? "" : this.lists[index].MEDICATION;
        this.anamnesisYn = index < 0 ? "N" : this.lists[index].ANAMNESIS_YN;
        this.anamnesis = [];

        this.insuranceChk = false;
        this.inGuarantee = "";
        this.balance = "";
        this.confirmDate = dateClass.getDate("YYYY-MM-DD");
        this.outpatDayLimit = "";
        this.outpatDayLimitText = "";
        this.outPatCount = "";
        this.indemStdt = "";
        this.indemEnddt = "";

        if (index < 0) this.anamnesis = [];
        else {
          if (this.lists[index].ANAMNESIS != "") {
            const anamnesisArray = this.lists[index].ANAMNESIS.trim().split(
              ","
            );
            this.anamnesis = anamnesisArray;
          }
        }
        this.anamnesisEtc = index < 0 ? "" : this.lists[index].ANAMNESIS_ETC;
        this.nutritionMemo = index < 0 ? "" : this.lists[index].NUTRITION_MEMO;
        this.kaako_sender = index < 0 ? 1 : this.lists[index].KAKAO_SENDER;

        if (index < 0) {
          this.medicalName = "";
          this.medicalNameText = "";
          this.insuranceName = "";
          this.insuranceNameText = "";
          this.inLimit = "";
          this.inLimitText = "";

          this.sickNess = "";
          this.sickNessText = "";
          this.address = "";
          // this.addressText = '';
          this.mealMemo = "";
          this.mealMemoText = "";
        } else {
          if (this.lists[index].MEDICAL_NAME == "") {
            this.medicalName = "";
            this.medicalNameText = "";
          } else {
            let nameTF = false;
            for (let i = 0; i < this.medicalCenterList.length; i++) {
              const medicalName = this.medicalCenterList[i].MEDICAL_CENTER_NAME;
              if (medicalName == this.lists[index].MEDICAL_NAME) {
                this.medicalName = this.lists[index].MEDICAL_NAME;
                this.medicalNameText = "";
                nameTF = true;
              }
            }
            if (!nameTF) {
              this.medicalName = "직접입력";
              this.medicalNameText = this.lists[index].MEDICAL_NAME;
            }
          }

          if (this.lists[index].INSURANCENAME == "") {
            this.insuranceName = "";
            this.insuranceNameText = "";
          } else if (this.lists[index].INSURANCENAME == "직접입력") {
            this.insuranceName = "직접입력";
            this.insuranceNameText = this.lists[index].INSURANCENAMETEXT;
            this.insuranceChk = true;
          } else {
            let nameTF = false;
            for (let i = 0; i < this.insuranceCenterList.length; i++) {
              const insuranceName = this.insuranceCenterList[i].INSURANCE_CENTER_CODE;
              if (insuranceName == this.lists[index].INSURANCENAME) {
                this.insuranceName = this.lists[index].INSURANCENAME;
                this.insuranceNameText = "";
                nameTF = true;
                this.insuranceChk = true;
              }
            }
            if (!nameTF) {
              this.insuranceName = "";
              this.insuranceNameText = "초기값";
            }
          }


          if (this.lists[index].INLIMIT == "") {
            this.inLimit = "";
            this.inLimitText = "";
          } else if (this.lists[index].INLIMIT == "etc") {
            this.inLimit = "etc";
            this.inLimitText = this.lists[index].INLIMITTEXT;
          } else {
            this.inLimit = this.lists[index].INLIMIT;
            this.inLimitText = "";
          }

          if (this.lists[index].INGUARANTEE == "") {
            this.inGuarantee = "";
          } else {
            this.inGuarantee = this.lists[index].INGUARANTEE;
          }

          if (this.lists[index].BALANCE == "") {
            this.balance = "";
          } else {
            this.balance = this.lists[index].BALANCE;
          }

          if (this.lists[index].BALANCE == "") {
            this.balance = "";
            this.confirmDate = dateClass.getDate("YYYY-MM-DD");
          } else {
            this.balance = this.lists[index].BALANCE;
            this.confirmDate = this.lists[index].CONFIRMDATE;
          }

          if (this.lists[index].OUTPATDAYLIMIT == "ETC") {
            this.outpatDayLimit = this.lists[index].OUTPATDAYLIMIT;
            this.outpatDayLimitText = this.lists[index].OUTPATDAYLIMITTEXT;
          } else {
            this.outpatDayLimit = this.lists[index].OUTPATDAYLIMIT;
            this.outpatDayLimitText = "";
          }

          if (this.lists[index].OUTPATCOUNT == "") {
            this.outPatCount = "";
          } else {
            this.outPatCount = this.lists[index].OUTPATCOUNT;
          }

          if (this.lists[index].INDEMSTDT == "") {
            this.indemStdt = "";
          } else {
            this.indemStdt = this.lists[index].INDEMSTDT;
          }

          if (this.lists[index].INDEMENDDT == "") {
            this.indemEnddt = "";
          } else {
            this.indemEnddt = this.lists[index].INDEMENDDT;
          }

          if (this.lists[index].SICKNESS == "") {
            this.sickNess = "";
            this.sickNessText = "";
          } else {
            let nameTF = false;
            for (let i = 0; i < this.sickNessList.length; i++) {
              const sickNess = this.sickNessList[i].SICKNESS;
              if (sickNess == this.lists[index].SICKNESS) {
                this.sickNess = this.lists[index].SICKNESS;
                this.sickNessText = "";
                nameTF = true;
              }
            }
            if (!nameTF) {
              this.sickNess = "직접입력";
              this.sickNessText = this.lists[index].SICKNESS;
            }
          }

          if (this.lists[index].MEAL_MEMO == "") {
            this.mealMemo = "";
            this.mealMemoText = "";
          } else {
            let nameTF = false;
            for (let i = 0; i < this.mealMemoList.length; i++) {
              const mealMemo = this.mealMemoList[i].MEALMEMO;
              if (mealMemo == this.lists[index].MEAL_MEMO) {
                this.mealMemo = this.lists[index].MEAL_MEMO;
                this.mealMemoText = "";
                nameTF = true;
              }
            }
            if (!nameTF) {
              this.mealMemo = "직접입력";
              this.mealMemoText = this.lists[index].MEAL_MEMO;
            }
          }
        }
        this.memo = index < 0 ? "" : this.lists[index].MEMO;
        this.corona = index < 0 ? "" : this.lists[index].CORONA;
        this.medicalRoomNm = index < 0 ? "" : this.lists[index].MEDICAL_ROOM_NM;
        console.log("this.medicalRoomNm=============>" + this.medicalRoomNm);
        if (this.cdStatus == 7) {
          this.medicalRoomNumberNm =
            index < 0 ? "" : this.lists[index].MEDICAL_ROOM_NUMBER_NM;
        } else {
          this.medicalRoomNumberNm =
            index < 0 ? "" : this.lists[index].MEDICAL_ROOM_NUMBER_NM;
        }
        // this.medicalRoomNumberNm = index < 0 ? '' : this.lists[index].MEDICAL_ROOM_NUMBER_NM;
        this.medicalRoomNumberCnt =
          index < 0 ? "" : this.lists[index].MEDICAL_ROOM_NUMBER_CNT;

        if (this.medicalRoomNm != "") await this.medicalRoomChange("Y");
        if (this.medicalRoomNumberNm != "")
          await this.medicalRoomNumberChange("Y");
        //알림톡 수신자 추가
        this.kakao_sender = index < 0 ? 1 : this.lists[index].KAKAO_SENDER;
        this.tabArray_01 = [];

        if (index >= 0) {
          for (let i = 0; i < this.roomlist.length; i++) {
            if (
              (this.lists[index].TABSUM & this.roomlist[i].TAB_CODE) !=
              false
            ) {
              this.tabArray_01.push(this.roomlist[i].TAB_CODE);
            }
          }
        }

        this.mainCs = index < 0 ? "" : this.lists[index].MAIN_CS_UID;
        this.mainCsCaller = index < 0 ? "" : this.lists[index].MAIN_CS_CALLER;
        this.mainCsCallerPhone =
          index < 0 ? "" : this.lists[index].MAIN_CALLER_PHONE;
        this.initPath = index < 0 ? "" : this.lists[index].INITPATH;
        this.etcMemo = index < 0 ? "" : this.lists[index].ETC_MEMO;
        this.roomMemo = index < 0 ? "" : this.lists[index].ROOM_MEMO;
        this.csMemo = index < 0 ? "" : this.lists[index].CS_MEMO;
        this.cs2Memo = index < 0 ? "" : this.lists[index].CS2_MEMO;

        if (type == "cs") {
          await this.popTabClick(2);
        } else {
          this.openPopup1 = !this.openPopup1;
        }
        // console.log(this.openPopup1);
      } catch (e) {
        console.log(e.response.data);
      }
    },
    dateStatusChange() {
      this.cdStatusChange_YN = "N";
    },
    //현재상태 및 신입재입 체크
    statusCheck(completeYn, inInitDate, inDate, outDate) {
      console.log("completeYn:" + completeYn);
      console.log("inInitDate:" + inInitDate);
      console.log("inDate:" + inDate);
      console.log("outDate:" + outDate);

      completeYn = completeYn || "N";

      inInitDate = inInitDate || "";

      inDate = inDate || "";
      outDate = outDate || "";
      let now_status = this.cdStatus;

      let diff = dateClass.dateDiff(outDate, inDate);

      this.now_day = dateClass.getDate("YYYY-MM-DD");

      let check = this.cdStatusChange_YN;

      if (check == "Y" && this.cdStatus == "14") {
        console.info("수동 또는 입원대기");
        return
      }

      console.info("자동");
      if (completeYn == "Y") {
        // 현재 상태 : 완퇴
        console.info("완퇴");
        this.cdStatus = "10";
        this.medicalRoomNumberNm = "완퇴";
      } else {
        // 현재 상태
        // if (this.cdStatus == '14') {
        //     // 입원대기
        //     this.cdStatus = '14';
        //     console.log('cdstatus:' + this.cdStatus);

        //     this.medicalRoomNm = '';
        //     this.medicalRoomNumberNm = '';
        //     this.medicalRoomNumberCnt = '';
        // }

        if (inInitDate == "") {
          // 외래
          console.info("외래 : inInitDate no data");
          this.cdStatus = "8";
          this.medicalRoomNm = "";
          this.medicalRoomNumberNm = "";
          this.medicalRoomNumberCnt = "";
        } else if (outDate == this.now_day) {
          // 퇴원일
          console.info("퇴원일");
          this.cdStatus = "12";

          if (now_status == 7) {
            this.medicalRoomNm = "";
            this.medicalRoomNumberNm = "";
            this.medicalRoomNumberCnt = "";
          }
        } else if (inDate < this.now_day) {
          // if (diff >= 0 && diff < 6 && inDate < outDate) {
          //     // 가퇴원
          //     this.cdStatus = '13';
          // } else
          if (outDate < this.now_day && inDate <= outDate) {
            // 퇴원
            console.info("퇴원");
            this.cdStatus = "7";
            this.medicalRoomNm = "";
            this.medicalRoomNumberCnt = "";
            this.medicalRoomNumberNm = "퇴원";
            // } else if(inDate < this.now_day && this.now_day < outDate) {
          } else {
            // 입원
            console.info("입원");
            this.cdStatus = "6";

            if (now_status != 6 && now_status != 11 && now_status != 12 && now_status != 13) {
              this.medicalRoomNm = "";
              this.medicalRoomNumberNm = "";
              this.medicalRoomNumberCnt = "";
            }
          }
        } else if (inDate == this.now_day) {
          // 입원일
          console.info("입원일");
          this.cdStatus = "11";
          if (now_status != 6) {
          }
        } else if (inDate > this.now_day) {
          if (diff >= 0 && diff < 6 && outDate <= this.now_day) {
            // 가퇴원
            console.info("가퇴원");
            this.cdStatus = "13";
          } else if (outDate < this.now_day) {
            // 입원예정
            console.info("입원예정");
            this.cdStatus = "9";
          } else if (outDate >= inDate) {
            // 입원예정
            console.info("입원예정");
            this.cdStatus = "9";
          } else {
            // 입원
            console.info("입원");
            this.cdStatus = "6";
          }
        }
        // } else if (inDate > this.now_day) {
        //   if (outDate < this.now_day) {
        //     if(diff >= 0 && diff < 4) {
        //       // 가퇴원
        //       console.info("가퇴원");
        //       this.cdStatus = "13";
        //     }
        //   } else if (this.now_day < inDate) {
        //     // 입원예정
        //     console.info("입원예정");
        //     this.cdStatus = "9";
        //   } else if (outDate >= inDate) {
        //     // 입원예정
        //     console.info("입원예정");
        //     this.cdStatus = "9";
        //   } else {
        //     // 입원
        //     console.info("입원");
        //     this.cdStatus = "6";
        //   }
        // }
      }


      //특정문자 포함 여부 상태값
      /*
      if (this.plan.includes("완퇴")) {
          this.cdStatus = "10";
          this.medicalRoomNumberNm = "완퇴";
          console.info("완퇴:" + this.cdStatus);
      }
      */

      // 신입재입 체크
      if (now_status == 6 && (inInitDate == "" || inDate == "")) {
        this.newRe = "오류";
      } else if (inDate > inInitDate && inInitDate != "" && inDate != "") {
        this.newRe = "재입";
      } else if (inDate == inInitDate && inInitDate != "" && inDate != "") {
        this.newRe = "신입";
      } else {
        this.newRe = "신입";
      }
    },

    // 주민등록번호 검사
    juminCheck() {
      let err_msg = "";
      const jumin_1 = this.jumin.split("-")[0] || "";
      const jumin_2 = this.jumin.split("-")[1] || "";

      const patientGenderCode =
        jumin_2 != undefined && jumin_2.length > 0 ? jumin_2.substr(0, 1) : "";
      const genderCode_2000_Array = ["3", "4", "7", "8"];
      const genderCode_1900_Array = ["1", "2", "5", "6"];
      const genderCode_1800_Array = ["9", "0"];
      const today = dateClass.getDate("YYYYMMDD");
      const today_Y = dateClass.getDate("YYYY");
      const jumin_1_2000 = "20" + jumin_1;
      if (
        this.jumin.indexOf("-") < 0 ||
        this.jumin.length != 14 ||
        (this.jumin.match(/-/g) != null &&
          this.jumin.match(/-/g).length != 1) ||
        isNaN(jumin_1) ||
        // isNaN(jumin_2) ||
        jumin_1.length != 6 ||
        jumin_2.length != 7 ||
        patientGenderCode == ""
      ) {
        err_msg =
          "주민번호를 [123456-1234567]형태로 올바르게 입력하여 주십시오.";
      } else {
        if (isNaN(patientGenderCode)) {
          err_msg = "주민번호 성별을 올바르게 입력하여 주십시오.";
        } else if (
          genderCode_2000_Array.indexOf(patientGenderCode) > -1 &&
          today < jumin_1_2000
        ) {
          err_msg = "2000년대의 생년월일을 확인하여 주십시오.";
        }
      }
      if (err_msg != "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: err_msg,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        this.juminTF = false;
        return;
      } else {
        this.patientGender = patientGenderCode % 2 == 0 ? "F" : "M";
        let patientBirth_MD = jumin_1.substr(2, 2) + "-" + jumin_1.substr(4, 2);
        let patientBirth_Y = jumin_1.substr(0, 2);
        if (genderCode_2000_Array.indexOf(patientGenderCode) > -1) {
          patientBirth_Y = "20" + patientBirth_Y;
        } else if (genderCode_1900_Array.indexOf(patientGenderCode) > -1) {
          patientBirth_Y = "19" + patientBirth_Y;
        } else if (genderCode_1800_Array.indexOf(patientGenderCode) > -1) {
          patientBirth_Y = "18" + patientBirth_Y;
        }
        this.patientBirthday = patientBirth_Y + "-" + patientBirth_MD;
        if (this.patientBirthday != "") {
          //   this.age = today_Y - patientBirth_Y + 1;

          // 230329 TH 새로운 나이 구하는 식
          let realAge = '';
          const todayNew = new Date();
          // 년 월 일 분리
          const birthDate = new Date(patientBirth_Y, jumin_1.substr(2, 2), jumin_1.substr(4, 2));

          realAge = todayNew.getFullYear() - birthDate.getFullYear();
          const monthDiff = todayNew.getMonth() - (birthDate.getMonth() - 1);

          if (monthDiff < 0 || (monthDiff == 0 && todayNew.getDate() < birthDate.getDate())) {
            realAge--;
          }

          this.age = realAge
        }

        this.juminTF = true;
      }
    },
    mainCsCallerChange(mainCsCallerValue) {
      if (mainCsCallerValue == 1) {
        if (this.patientPhone == "") {
          this.patientPhone = this.mainCsCallerPhone;
        } else {
          this.mainCsCallerPhone = this.patientPhone;
        }
      } else if (mainCsCallerValue == 2) {
        if (this.protectorPhone == "") {
          this.protectorPhone = this.mainCsCallerPhone;
        } else {
          this.mainCsCallerPhone = this.protectorPhone;
        }
        // this.mainCsCallerPhone = this.protectorPhone;
      } else if (mainCsCallerValue == 3) {
        if (this.protectorPhone2 == "") {
          this.protectorPhone2 = this.mainCsCallerPhone;
        } else {
          this.mainCsCallerPhone = this.protectorPhone2;
        }
        // this.mainCsCallerPhone = this.protectorPhone2;
      } else {
        this.mainCsCallerPhone = "";
      }
    },
    //병동선택 change
    async medicalRoomChange(first = "N") {
      let params = {
        medicalRoomNm: this.medicalRoomNm,
      };
      const { data } = await axiosClass.get(
        "/api/patient/medicalRoomNumberList2",
        params,
        true
      );
      this.medicalRoomNumberList2 = data.medicalRoomNumberList2;

      if (first == "N") {
        this.medicalRoomNumberNm = "";
        this.medicalRoomNumberCntList = [];
        this.medicalRoomNumberCnt = "";
      }
    },
    //병실선택 change
    async medicalRoomNumberChange(first = "N") {
      let params = {
        medicalRoomNumberNm: this.medicalRoomNumberNm,
      };

      const { data } = await axiosClass.get(
        "/api/patient/medicalRoomNumberCntList",
        params,
        true
      );

      this.medicalRoomNumberCntList = data.medicalRoomNumberCntList;
      if (first == "N") {
        this.medicalRoomNumberCnt = "";
      }
    },
    dateInit() {
      this.inDate = null;
      this.outDate = null;
    },
    //현재상태 change
    cdStatusChange() {
      console.info("cdStatusChange");
      if (this.cdStatus != "9" && this.cdStatus != "14") {
        this.medicalRoomNm = "";
        this.medicalRoomNumberNm = "";
        this.medicalRoomNumberCnt = "";
        this.medicalRoomNumberList2 = [];
        this.medicalRoomNumberCntList = [];
      }
      this.cdStatusChange_YN = "Y";

      console.info("cdStatusChange_YN:" + this.cdStatusChange_YN);
    },
    //환자 추가 및 수정 팝업닫기
    onClickModifyHide() {
      this.openPopup1 = !this.openPopup1;
    },

    //환자 삭제 확인(컨펌)창
    onClickDeleteConfirm(index) {
      this.listIndex = index;
      this.patientUid = this.lists[this.listIndex].PATIENT_UID;
      this.lists
      this.patientName = this.lists[this.listIndex].PATIENT_USERNAME;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "삭제",
        text: "해당 환자(" + this.patientName + ")를 정말로 삭제하시겠습니까?",
        acceptText: "삭제",
        cancelText: "취소",
        accept: this.onClickDelete,
      });
    },
    //환자 삭제 처리
    async onClickDelete() {
      try {
        let params = {
          userUid: this.userUid,
        };
        const { data } = await axiosClass.delete(
          "/api/patient/delete/" + this.patientUid,
          params,
          true
        );

        this.lists.splice(this.listIndex, 1);
        this.$vs.notify({
          color: "danger",
          title: "삭제 완료",
          text: "환자(" + this.patientName + ") 삭제가 완료되었습니다.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      } catch (e) {
        console.log(e.response.data);
      }
      this.listIndex = -1;
      this.patientUid = "";
      this.patientName = "";
    },
    //스케줄 클릭 처리
    onClickSchedule(index) {
      this.listIndex = index;
      this.patientUid = this.lists[this.listIndex].PATIENT_UID;
      // this.$router.push("/patientSchedule/scheduleCalendar/" + this.patientUid);
      this.$router.push({ name: 'scheduleCalendar', params: { uid: this.patientUid } });
    },

    kakaoClose() {
      this.kakaoPopup = false;
    },
    async kakaoSend() {
      if (this.messageSelect == false) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "발송 메시지를 선택해주세요.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      } else if (this.messageResponder_1 == false && this.messageResponder_2 == false && this.messageResponder_3 == false) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "발송 대상자를 선택해주세요.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      }
      const params = {
        schedule_date: this.kakao_date,
        messageSelect: this.messageSelect,
        messageResponder_1: this.messageResponder_1,
        messageResponder_2: this.messageResponder_2,
        messageResponder_3: this.messageResponder_3,
      };
      const { data } = await axiosClass.post(
        "/api/patient/kakaoSend/" + this.patientUid,
        params,
        true
      );

      if (data.success == false) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "금일 발송할 스케쥴이 존재하지 않습니다.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {

        this.$vs.notify({
          title: "Success",
          text: "정상적으로 발송되었습니다.",
          color: "success",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });

      }

      this.kakaoPopup = false;
    },

    async onClickAlram(index) {
      let params = {};
      this.patientUid = this.lists[index].PATIENT_UID;
      this.kakao_date = moment().format("YYYY-MM-DD");
      this.alramTalk = true;
    },

    //카톡보내기 클릭 처리
    async onClickKakao(index) {
      // if (this.$store.state.cd_level > 1) {
      //     this.$vs.notify({
      //         color: 'danger',
      //         title: '오류',
      //         text: '발송권한이 없습니다.',
      //         position: 'top-right',
      //         iconPack: 'feather',
      //         icon: 'icon-check',
      //     });
      //     return;
      // }

      let params = {};
      this.patientUid = this.lists[index].PATIENT_UID;
      this.kakao_date = moment().format("YYYY-MM-DD");
      this.kakaoPopup = true;
      this.messageSelect = "";
      this.messageResponder_1 = false;
      this.messageResponder_2 = false;
      this.messageResponder_3 = false;
      /** 발송 */
      // const { data } = await axiosClass.post('/api/patient/kakaoSend/' + this.patientUid, params, true);
      // if (data.success == false) {
      //     this.$vs.notify({
      //         color: 'danger',
      //         title: '오류',
      //         text: '금일 발송할 스케쥴이 존재하지 않습니다.',
      //         position: 'top-right',
      //         iconPack: 'feather',
      //         icon: 'icon-check',
      //     });
      // } else {
      //     this.$vs.notify({
      //         title: 'Success',
      //         text: '정상적으로 발송되었습니다.',
      //         color: 'success',
      //         position: 'top-right',
      //         iconPack: 'feather',
      //         icon: 'icon-check',
      //     });
      // }

      // this.$vs.notify({
      //     color: 'danger',
      //     title: '작업 대기',
      //     text: '작업 대기 중 입니다.',
      //     position: 'top-right',
      //     iconPack: 'feather',
      //     icon: 'icon-check',
      // });
    },
    activeMenu(medical_room_seq) {
      if (medical_room_seq == this.medical_room_seq) {
        return "activeMenu";
      } else {
        return "";
      }
    },
    openUploadPopup() {
      this.$refs.excelupload.popupEvent();
    },
    async listDownload() {
      let params = {
        userUid: this.userUid,
      };

      const { data } = await axiosClass.get(
        "/api/patient/listExcel",
        params,
        true
      );

      const book = XLSX.utils.book_new();
      const options = {
        // skipHeader: true,
        // header: ['UID', '이름', 'ID', '비밀번호', '이메일', 'LEVEL', '부서', '팀', '직책', '직급', '등록일', '수정일', '응답상태'],
        // header: [ 'PATIENT_UID', '이름', 'ID', '비밀번호', '이메일', 'LEVEL', '부서', '팀', '직책', '직급', '등록일', '수정일', '응답상태'],
      };

      const sheet = XLSX.utils.json_to_sheet(data.lists, options);
      XLSX.utils.book_append_sheet(book, sheet);
      XLSX.writeFile(
        book,
        `${dateClass.getDate("YYYYMMDDHHmmss")}_환자리스트.xlsx`
      );
    },

    anamnesisInput() {
      this.anamnesisEtc =
        this.anamnesis.indexOf("기타") < 0 ? "" : this.anamnesisEtc;
    },

    async onClickCs() {
      // patientUid가 없으면 API 호출하지 않음
      if (!this.patientUid || this.patientUid === 'undefined' || this.patientUid === undefined) {
        console.warn('[patient/List] patientUid is undefined, skipping API call');
        return;
      }

      this.csDatas = [];
      let params = {
        patientUid: this.patientUid,
      };
      try {
        console.log(params);
        const { data } = await axiosClass.get(
          "/api/patient/cs/" + this.patientUid,
          params,
          true
        );
        console.log("data:" + data);
        if (data.csDatas.length > 0) {
          this.csDatas = data.csDatas;
        }
      } catch (err) {
        alert("데이터 불러오는데 오류가 발생되었습니다.");
      }
    },
    // 20210607 PG:H 수정
    addClickCs() {
      const tempCsData = {
        CS_CATE_CODE: "",
        CS_CONTENT: "",
        CS_DATE: dateClass.getDate("YYYY-MM-DD"),
        CS_TIME: dateClass.getDate("HH:mm:ss"),
        CS_FAVOR_CODE: "",
        CS_ISSUE_CODE: "",
        CS_MEMBER_CODE: this.userUid,
        CS_PATH_CODE: "",
        INQUIRER: this.mainCsCaller,
        NEXT_DATE: "",
        PATIENT_UID: this.patientUid,
        PHONE: "",
        RELATION: "",
        SEQ: 0,
        CS_ISSUE_TEXT: "",
      };
      this.csDatas.unshift(tempCsData);

      // console.log(this.mainCsCaller);
    },
    //상담내역 삭제 확인(컨펌)창
    // csDeleteConfirm(index) {
    //     console.log('삭제컨펌창');
    //     const csSeq = this.csDatas[index].SEQ;
    //     this.$vs.dialog({
    //         type: 'confirm',
    //         color: 'danger',
    //         title: '삭제',
    //         text: '해당 상담내역을 정말로 삭제하시겠습니까?',
    //         acceptText: '삭제',
    //         cancelText: '취소',
    //         accept: this.removeClickCs(index),
    //     });
    // },
    async removeClickCs(index) {
      const csSeq = this.csDatas[index].SEQ;

      if (csSeq > 0) {
        await axiosClass.delete("/api/patient/cs/" + csSeq, true);
      }
      this.csDatas.splice(index, 1);
      this.$vs.notify({
        color: "danger",
        title: "삭제 완료",
        text: "삭제가 완료되었습니다.",
        position: "top-right",
        iconPack: "feather",
        icon: "icon-check",
      });
    },
    async saveClickCs(type) {
      console.info("saveClickCs");

      // patientUid가 없으면 API 호출하지 않음
      if (!this.patientUid || this.patientUid === 'undefined' || this.patientUid === undefined) {
        console.warn('[patient/List] patientUid is undefined, skipping save');
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "환자 정보를 확인해주세요.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      if (this.csDatas.length < 1) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "상담내역이 존재하지 않습니다.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      }

      let err_msg = "";
      let objName = "";
      let checkBoolean = false;
      for (let i = 0; i < this.csDatas.length; i++) {
        const data = this.csDatas[i];
        const csPathCode = data.CS_PATH_CODE;
        const csCateCode = data.CS_CATE_CODE;
        const csMeberCode = data.CS_MEMBER_CODE;
        const inquirer = data.INQUIRER;
        const phone = data.PHONE;
        const relation = data.RELATION;
        const csFavorCode = data.CS_FAVOR_CODE;
        const nextDate = data.NEXT_DATE;
        const csIssueCode = data.CS_ISSUE_CODE;
        const csIssueText = data.CS_ISSUE_TEXT;
        const csContent = data.CS_CONTENT;

        console.log("csFavorCode:" + csFavorCode);
        console.log("nextDate:" + nextDate);
        if (csFavorCode == 0) {
          this.$vs.notify({
            color: "danger",
            title: "오류",
            text: "다음일정 종류를선택해주세요.",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });
          return;
        }

        if (csFavorCode == 1 || csFavorCode == 2 || csFavorCode == 3) {
          if (nextDate == "" || nextDate == "null") {
            this.$vs.notify({
              color: "danger",
              title: "오류",
              text: "예정일을 입력해주세요.",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            return;
          }
        }

        if (csFavorCode == 6 || csFavorCode == 7) {
          if (csIssueCode == "" || csIssueCode == "null") {
            this.$vs.notify({
              color: "danger",
              title: "오류",
              text: "부정이슈 종류를 선택해주세요.",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            return;
          }

          if (csIssueCode == 8) {
            if (csIssueText == "" || csIssueText == "null") {
              this.$vs.notify({
                color: "danger",
                title: "오류",
                text: "부정이슈 내용을 입력해주세요.",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-check",
              });
              return;
            }
          }
        }

        if (err_msg != "") {
          this.$vs.notify({
            color: "danger",
            title: "오류",
            text: err_msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });

          if (objName == "nextDate") {
            const dateDiv = document.querySelectorAll(
              'div[name="' + objName + '"]'
            )[i];
            const dateInput = dateDiv.querySelector('input[name="date"]');
            dateInput.focus();
          } else if (objName == "csContent") {
            document
              .querySelectorAll('textarea[name="' + objName + '"]')
            [i].focus();
          } else {
            document
              .querySelectorAll('input[name="' + objName + '"]')
            [i].focus();
          }

          return;
        }
      }

      const params = {
        csDatas: this.csDatas,
      };
      console.log(params);

      const { data } = await axiosClass.post(
        "/api/patient/cs/" + this.patientUid,
        params,
        true
      );
      if (!data.success) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: data.err_msg,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }
      if (type != "save") {
        this.$vs.notify({
          title: "Success",
          text: "정상적으로 등록되었습니다.",
          color: "success",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });

        // await this.onClickModifyCs('csSave');
      }

      setTimeout(() => {
        this.$vs.loading.close("#list > .con-vs-loading");
        this.openPopup1 = false;
        this.csPopup = false;
      }, 100);
    },

    activeMenu2(popTabIdx) {
      if (popTabIdx == this.popTabIdx) {
        return "activeMenu2";
      } else {
        return "";
      }
    },
    // 20210607 PG:H 수정
    async popTabClick(popTabIdx) {
      console.log("데이터 호출");
      this.$vs.loading();
      // console.log('this.patientUid:::', this.patientUid);

      let checkedTF = false;
      if (popTabIdx == 2) {
        // if (this.patientUid == '') {
        //     checkedTF = await this.onClickModify('t');
        //     if (!checkedTF) {
        //         return;
        //     }
        // }
        await this.onClickCs();
      }
      this.popTabIdx = popTabIdx;

      setTimeout(() => {
        this.$vs.loading.close();
        if (popTabIdx == 2) {
          this.openPopup1 = false;
          this.csPopup = true;
        } else {
          this.csPopup = false;
          this.openPopup1 = true;
        }
      }, 1000);
    },

    getPhoneMask(val, type) {
      console.log("mainCsCallerPhone" + this.mainCsCaller);
      let res = this.getMask(val);
      if (type == "patientPhone") {
        this.patientPhone = res;
        //서버 전송 값에는 '-' 를 제외하고 숫자만 저장
        // this.patientPhone = this.patientPhone.replace(/[^0-9]/g, '');
      }
      if (type == "protectorPhone") {
        this.protectorPhone = res;
      }
      if (type == "protectorPhone2") {
        this.protectorPhone2 = res;
      }
      if (type == "mainCsCallerPhone") {
        console.log("mainCsCallerPhone" + this.mainCsCaller);
        if (this.mainCsCaller == "") {
          this.mainCsCallerPhone = "";
        } else {
          this.mainCsCallerPhone = res;
        }
      }
    },
    juminAddString(jumin) {
      if (event.keyCode === 8) {
        return false
      } else if ((event.keyCode === 109) || (event.keyCode === 189)) {
        event.preventDefault();
      } else if (jumin.length == 7) {

        const jumin_fore = jumin.substr(0, 6) || "";
        const jumin_post = jumin.substr(6, 7) || "";
        let juminString = '';
        this.jumin = jumin_fore + '-' + jumin_post;
      }
    },
    getMask(phoneNumber) {
      if (!phoneNumber) return phoneNumber;
      phoneNumber = phoneNumber.replace(/[^0-9]/g, "");

      let res = "";
      if (phoneNumber.length < 3) {
        res = phoneNumber;
      } else {
        if (phoneNumber.substr(0, 2) == "02") {
          if (phoneNumber.length <= 5) {
            //02-123-5678
            res = phoneNumber.substr(0, 2) + "-" + phoneNumber.substr(2, 3);
          } else if (phoneNumber.length > 5 && phoneNumber.length <= 9) {
            //02-123-5678
            res =
              phoneNumber.substr(0, 2) +
              "-" +
              phoneNumber.substr(2, 3) +
              "-" +
              phoneNumber.substr(5);
          } else if (phoneNumber.length > 9) {
            //02-1234-5678
            res =
              phoneNumber.substr(0, 2) +
              "-" +
              phoneNumber.substr(2, 4) +
              "-" +
              phoneNumber.substr(6);
          }
        } else {
          if (phoneNumber.length < 8) {
            res = phoneNumber;
          } else if (phoneNumber.length == 8) {
            res = phoneNumber.substr(0, 4) + "-" + phoneNumber.substr(4);
          } else if (phoneNumber.length == 9) {
            res =
              phoneNumber.substr(0, 3) +
              "-" +
              phoneNumber.substr(3, 3) +
              "-" +
              phoneNumber.substr(6);
          } else if (phoneNumber.length == 10) {
            res =
              phoneNumber.substr(0, 3) +
              "-" +
              phoneNumber.substr(3, 3) +
              "-" +
              phoneNumber.substr(6);
          } else if (phoneNumber.length > 10) {
            //010-1234-5678
            res =
              phoneNumber.substr(0, 3) +
              "-" +
              phoneNumber.substr(3, 4) +
              "-" +
              phoneNumber.substr(7);
          }
        }
      }
      console.log("res:" + res);
      return res;
    },
    onClickMemberView (type, pUid) {
      console.log(pUid);
        let uid = '';
        if (pUid != null && pUid != undefined && pUid != '') {
          uid = pUid
        } else {
          uid = this.patient_member_uid;
        }

          if (type == 'patient') {
            this.$EventBus.$emit('memberView', uid);
          } else {
            this.$EventBus.$emit('memberCs', uid);
          }
      },
      async listDownloadEssential() {
          let params = {
            userUid: this.userUid,
          };
          const { data } = await axiosClass.get(
            "/api/patient/listExcelEssential",
            params,
            true
          );
          const book = XLSX.utils.book_new();
          const options = {
            // skipHeader: true,
            // header: ['UID', '이름', 'ID', '비밀번호', '이메일', 'LEVEL', '부서', '팀', '직책', '직급', '등록일', '수정일', '응답상태'],
            // header: [ 'PATIENT_UID', '이름', 'ID', '비밀번호', '이메일', 'LEVEL', '부서', '팀', '직책', '직급', '등록일', '수정일', '응답상태'],
          };
          const sheet = XLSX.utils.json_to_sheet(data.lists, options);
          XLSX.utils.book_append_sheet(book, sheet);
          XLSX.writeFile(
            book,
            `${dateClass.getDate("YYYYMMDDHHmmss")}_환자리스트필수.xlsx`
          );
        },
    async kakaoAllSend() {
      
      const params = {
        schedule_date: this.kakao_date,
        messageSelect: this.messageSelect,
        messageResponder_1: this.messageResponder_1,
        messageResponder_2: this.messageResponder_2,
        messageResponder_3: this.messageResponder_3,
      };
      const { data } = await axiosClass.post(
        "/api/patient/kakaoAllSend/",
        params,
        true
      );

      if (data.success == false) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "스케쥴 발송이 실패하였습니다.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {

        this.$vs.notify({
          title: "Success",
          text: "정상적으로 발송되었습니다.",
          color: "success",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });

      }
      this.kakaoPopup = false;
    },
  },
  async mounted() {
    window.addEventListener("resize", this.handleResize);
    this.kakao_date = moment().format("YYYY-MM-DD");
    this.tab_sum = store.getters.getTABSUM;
    await this.init("");

    EventBus.$on('remoteListRefresh', async () => {
        this.init('');
    });
    EventBus.$on('remoteListCsRefresh', async () => {
        this.init('');
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style>
.mx-datepicker-popup {
  z-index: 90000000 !important;
}

.activeMenu {
  border-color: #015666;
}

.activeMenu2 {
  border-bottom-width: 3px !important;
  border-color: #015666;
}

.tb_box {
  height: 630px;
  overflow: auto;
}

input::placeholder {
  color: rgb(185, 185, 185);
}

/* .divFixed {
    position: fixed;
    top: 300px;
    index: 999;
} */

#memberPopup .vs-popup {
  width: 1200px !important;
}

#csPopup .vs-popup {
  width: 1200px !important;
}

.p-2 border border-solid text-center {
  padding: 0px;
  margin: 0px;
}

.colored {
  padding: 0px;
}
</style>
